import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Paper } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

const DealershipManagement = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <BusinessIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            {t('pages.dealershipManagement')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('pages.underConstruction')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default DealershipManagement;
